<template>
  <v-card>
    <v-divider></v-divider>
    <v-card-text v-if="!this.ids.queryCommission">
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <!-- <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.inter}}</v-subheader>

            <div class="title">{{this.$store.state.adminInter.intermediary.inter}}</div>
          </v-flex> -->
          <v-flex xs6 v-if="!newCommission">
            <v-subheader class="queryLabel">{{labels.effDate}}</v-subheader>
            <div class="title">{{formatDate(commissionForm.effDate)}}</div>
            <!-- <div class="title">{{commissionForm.effDate}}</div> -->
            <!-- <cal-picker :label="labels.effDate" v-model="commissionForm.effDate" :error-messages="errors.collect('effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate" v-validate="'required'" :disabled="!newCommission"></cal-picker> -->
          </v-flex>
          <v-flex xs6 v-else>
            <cal-picker :label="labels.effDate" v-model="commissionForm.effDate" :error-messages="errors.collect('effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate" v-validate="'required'"></cal-picker>
          </v-flex>
          <v-flex xs6 v-if="!newCommission">
            <v-subheader class="queryLabel">{{labels.polType}}</v-subheader>
            <div class="title">{{commissionForm.polType}}</div>
            <!-- <v-autocomplete :label="labels.polType" v-model="commissionForm.polType" :items="interPolTypeList" item-text="label" item-value="value" data-vv-name="polType" :data-vv-as="labels.polType" :error-messages="errors.collect('polType')" v-validate="'required'" :disabled="!newCommission"></v-autocomplete> -->
          </v-flex>
          <v-flex xs6 v-else>
            <v-autocomplete :label="labels.polType" v-model="commissionForm.polType" :items="interPolTypeList" item-text="label" item-value="value" data-vv-name="polType" :data-vv-as="labels.polType" :error-messages="errors.collect('polType')" v-validate="'required'" :disabled="!newCommission"></v-autocomplete>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.commPct" v-model="commissionForm.commPct" :error-messages="errors.collect('commPct')" v-validate="'required|mask_decimal:3|mask_min_value:1'" data-vv-name="commPct" :data-vv-as="labels.commPct" :disabled="commissionForm.void_"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-checkbox :label="labels.protComm" v-model="commissionForm.protComm" :error-messages="errors.collect('protComm')" data-vv-name="protComm" :data-vv-as="labels.protComm" :disabled="commissionForm.void_"></v-checkbox>
          </v-flex>
          <v-flex xs6>
            <v-select :items="interGrossNetList" v-model="commissionForm.commGn" :label="labels.commGn" item-text="label" item-value="value" data-vv-name="commGn" :data-vv-as="labels.commGn" :error-messages="errors.collect('commGn')" :disabled="commissionForm.void_"></v-select>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.discPct" v-model="commissionForm.discPct" :error-messages="errors.collect('discPct')" v-validate="'mask_decimal:3'" data-vv-name="discPct" :data-vv-as="labels.discPct" :disabled="commissionForm.void_"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-checkbox :label="labels.protDisc" v-model="commissionForm.protDisc" :error-messages="errors.collect('protDisc')" data-vv-name="protDisc" :data-vv-as="labels.protDisc" :disabled="commissionForm.void_"></v-checkbox>
          </v-flex>
          <v-flex xs6 v-if="commissionForm.void_">
            <v-checkbox :label="labels.void_" v-model="commissionForm.void_" :error-messages="errors.collect('void_')" data-vv-name="void_" :data-vv-as="labels.void_"></v-checkbox>
          </v-flex>
          <v-flex xs6 v-if="commissionForm.void_">
            <v-text-field :label="labels.voidReason" v-model="commissionForm.voidReason" :error-messages="errors.collect('voidReason')" v-validate="'required|max:200'" data-vv-name="voidReason" :data-vv-as="labels.voidReason"></v-text-field>
          </v-flex>
          <v-flex xs6>
          </v-flex>
          <v-flex xs6 v-if="!newCommission">
            <v-subheader class="queryLabel">{{labels.createdBy}}</v-subheader>
            <div class="title">{{createdBy}}</div>
            <!-- <v-text-field :label="labels.createdBy" v-model="createdBy" data-vv-name="createdBy" :data-vv-as="labels.createdBy" disabled></v-text-field> -->
          </v-flex>
          <v-flex xs6 v-if="!newCommission">
            <v-subheader class="queryLabel">{{labels.createdDate}}</v-subheader>
            <div class="title">{{formatDate(createdDate)}}</div>
            <!-- <cal-picker :label="labels.createdDate" v-model="createdDate" data-vv-name="createdDate" :data-vv-as="labels.createdDate" disabled></cal-picker> -->
          </v-flex>
          <v-flex xs6 v-if="!newCommission">
            <v-subheader class="queryLabel">{{labels.modifiedBy}}</v-subheader>
            <div class="title">{{modifiedBy}}</div>
            <!-- <v-text-field :label="labels.modifiedBy" v-model="modifiedBy" data-vv-name="modifiedBy" :data-vv-as="labels.modifiedBy" disabled></v-text-field> -->
          </v-flex>
          <v-flex xs6 v-if="!newCommission">
            <v-subheader class="queryLabel">{{labels.modifiedDate}}</v-subheader>
            <div class="title">{{formatDate(modifiedDate)}}</div>
            <!-- <cal-picker :label="labels.modifiedDate" v-model="modifiedDate" data-vv-name="modifiedDate" :data-vv-as="labels.modifiedDate" disabled></cal-picker> -->
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-text v-else>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.effDate}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{formatDate(commissionForm.effDate)}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.polType}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{commissionForm.polType}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.commPct}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{commissionForm.commPct}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.protComm}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{commissionForm.protComm}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.commGn}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{commissionForm.commGn}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.discPct}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{commissionForm.discPct}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.protDisc}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{commissionForm.protDisc}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.void_}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{commissionForm.void_}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.voidReason}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{commissionForm.voidReason}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.createdBy}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{createdBy}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.createdDate}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{formatDate(createdDate)}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.modifiedBy}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{modifiedBy}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.modifiedDate}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{formatDate(modifiedDate)}}</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-flex xs12 v-if="!this.ids.queryCommission">
      <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
        {{ newCommission ? 'Save Commission' : 'Update Commission' }}
        <v-icon right>{{newCommission ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
      </v-btn>
    </v-flex>
  </v-card>
</template>

<script>
import { interGrossNet } from '@/const/underwriting'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
import { formatDisplayDateTime, formatDisplayDate, formatDisplayDateTime3 } from '@/utils/date'
import toDate from 'date-fns/toDate'

export default {
  data() {
    return {
      labels: {
        inter: 'Inter',
        effDate: 'Effective Date*',
        polType: 'Policy Type*',
        commPct: 'Rate %*',
        protComm: 'Protect Rate',
        commGn: 'Gross or Net',
        discPct: 'Discount %',
        protDisc: 'Protect Discount',
        void_: 'Void',
        voidReason: 'Void Reason',
        createdBy: 'Created by',
        createdDate: 'Created Date',
        modifiedBy: 'Modified by',
        modifiedDate: 'Modified Date'
      },
      commissionForm: {
        inter: null,
        effDate: null,
        polType: null,
        commPct: 0,
        protComm: false,
        commGn: 'G',
        discPct: 0,
        protDisc: false,
        void_: null,
        voidReason: null
      },
      submitting: false,
      newCommission: false,
      interPolTypeList: [],
      createdBy: undefined,
      createdDate: undefined,
      modifiedBy: undefined,
      modifiedDate: undefined
    }
  },
  watch: {
    'ids.commissionNo': function (value) {
      this.doClearForm()
      this.getInterPolTypeList()
      if (value === 'new') {
        this.newCommission = true
        this.commissionForm.inter = this.ids.inter
        this.commissionForm.effDate = new Date()
      } else {
        this.newCommission = false
        if (value !== null) {
          this.doInit()
        }
      }
    }
  },
  computed: {
    // schemeMenu() {
    //   return this.$store.state.parameters.scheme.schemeMenu
    // },
    interGrossNetList() {
      let result = []
      Object.keys(interGrossNet).forEach(function(key) {
        const status = interGrossNet[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  methods: {
    async doInit() {
      this.commissionForm.inter = this.ids.inter
      this.commissionForm.effDate = this.ids.effDate
      this.commissionForm.polType = this.ids.polType
      if (!this.newCommission) {
        const apiURI = this.$store.state.adminInter.intermediary.menu.getCommission
        // const apiURI = this.schemeMenu.menu.pkgPlan
        if (apiURI) {
          try {
            const expand = {
              inter: this.ids.inter,
              effDate: formatDisplayDateTime3(this.ids.effDate),
              polType: this.ids.polType
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.commissionForm.commPct = data.commission.commPct
              this.commissionForm.protComm = data.commission.protComm
              if (data.commission.commGn === 'Gross') {
                this.commissionForm.commGn = 'G'
              } else if (data.commission.commGn === 'Net') {
                this.commissionForm.commGn = 'N'
              }
              // this.commissionForm.commGn = data.commission.commGn
              this.commissionForm.discPct = data.commission.discPct
              this.commissionForm.protDisc = data.commission.protDisc
              this.commissionForm.void_ = data.commission.void_
              this.commissionForm.voidReason = data.commission.voidReason
              this.createdDate = data.commission.createdDate
              this.modifiedDate = data.commission.modifiedDate

              this.createdBy = data.strCreatedBy
              this.modifiedBy = data.strModifiedBy

              this.menu = extractMenu(result.data._links)
            } else {
              this.errorMessage('Fail to load Data from server. Please try to refresh page')
            }
          } catch (error) {
            const { data } = error.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        } else {
          this.errorMessage('The request failed because it is trying to execute an invalid API url. - Package Plan Form')
        }
      }
    },
    async getInterPolTypeList() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.polTypeList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.interPolTypeList = data
        }
      } catch (err) {
        throw err
      }
    },
    async doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newCommission) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.createCommission
      if (apiURI) {
        try {
          const formatForm = {
            inter: this.commissionForm.inter,
            effDate: this.commissionForm.effDate,
            polType: this.commissionForm.polType,
            commPct: this.commissionForm.commPct,
            protComm: this.commissionForm.protComm,
            commGn: this.commissionForm.commGn,
            discPct: this.commissionForm.discPct,
            protDisc: this.commissionForm.protDisc
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$emit('resetTab')
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url. - Commission Create')
      }
    },
    removeFormatDate(date) {
      if (date === null) {
        return null
      } else if (date === undefined) {
        return null
      } else if (date === '') {
        return null
      } else {
        var dateString = date
        var dateParts = dateString.split('/')
        return new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
      }
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(toDate(xDate))
      }
    },
    formateDateTime(dateTime) {
      return formatDisplayDateTime(dateTime)
    },
    async doUpdate() {
      const apiURI = this.menu.updateCommission
      if (apiURI) {
        try {
          const formatForm = {
            inter: this.commissionForm.inter,
            effDate: this.commissionForm.effDate,
            polType: this.commissionForm.polType,
            commPct: parseFloat(this.commissionForm.commPct),
            protComm: this.commissionForm.protComm,
            commGn: this.commissionForm.commGn,
            discPct: parseFloat(this.commissionForm.discPct),
            protDisc: this.commissionForm.protDisc,
            voidReason: this.commissionForm.voidReason
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$emit('resetTab')
          }
        } catch (error) {
          const { data } = error.message
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url. - Commission Update')
      }
    },
    doClearForm() {
      this.resetValidator()
      this.resetMessages()
      this.commissionForm.inter = this.ids.inter
      this.commissionForm.effDate = null
      this.commissionForm.polType = null
      this.commissionForm.commPct = 0
      this.commissionForm.protComm = false
      this.commissionForm.commGn = 'G'
      this.commissionForm.discPct = 0
      this.commissionForm.protDisc = false
      this.commissionForm.void_ = null
      this.commissionForm.voidReason = null
      this.createdDate = null
      this.modifiedDate = null
      this.createdBy = null
      this.modifiedBy = null
    }
  },
  mixins: [
    MessageMixin
  ],
  props: {
    ids: {
      type: Object,
      default() {
        return {
          commissionNo: null
        }
      }
    }
  }
}
</script>

<style>
</style>
